(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
  if(!event.target.matches('.tm-site-quantity'))return;
  const input=event.target.closest('.tm-native-control').querySelector('[data-quantity-input]');
  input.value=event.target.value;
  input.dispatchEvent(new Event('change',{bubbles:true}));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tyresme-extra-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const labelsNode = document.getElementById('tyresme-filter-labels');
  if (!labelsNode) return;
  const text = JSON.parse(labelsNode.textContent);
  const extraKeys = ['tm_origin', 'tm_oem', 'tm_min', 'tm_max'];
  let base = [];
  let params;
  let sizePromise;
  const parts = row => row.front && row.rear ? [row.front, row.rear] : [row];
  const pairText = value => String(value ?? '').toUpperCase().replace(/\b(NULL|UNDEFINED)\b/g, '').replace(/[^A-Z0-9*+]/g, '');
  function correctedProduct(product) {
    if (pairText(product.product_title) !== 'ROTALLA27535R21103YEV01ELECTSILENT2026') return product;
    const corrected = {...product};
    ['model', 'dot'].forEach(key => { if (String(corrected[key]) === '2024') corrected[key] = '2026'; });
    return corrected;
  }
  const correctedRow = row => row.front && row.rear ? {...row, front: correctedProduct(row.front), rear: correctedProduct(row.rear)} : correctedProduct(row);
  function pairBadges(value) {
    return [...new Set(String(value || '').split(',').map(value => {
      let name = value.trim();
      try { name = decodeURIComponent(name.split('?')[0].split('/').pop()); } catch (_) {}
      return pairText(name.replace(/\.(png|webp|jpe?g|svg)$/i, '').replace(/_[a-f0-9]{8}-[a-f0-9-]{27,}/ig, ''));
    }).filter(Boolean))].sort().join('|');
  }
  function matchingPair(row, query) {
    if (!['rear_width', 'rear_height', 'rear_rim'].every(key => query.has(key))) return true;
    if (!row.front || !row.rear) return false;
    const {front, rear} = row;
    if (!(Number(front.inventory_quantity) >= 2 && Number(rear.inventory_quantity) >= 2)) return false;
    if (!['width', 'height', 'rim'].every(key => pairText(front[key]) === pairText(query.get(key)) && pairText(rear[key]) === pairText(query.get('rear_' + key)))) return false;
    if (!pairText(front.product_vendor) || !pairText(front.pattern)) return false;
    if (!['product_vendor', 'pattern', 'model', 'dot'].every(key => pairText(front[key]) === pairText(rear[key]))) return false;
    if (!['oem', 'markings'].every(key => pairBadges(front[key]) === pairBadges(rear[key]))) return false;
    const titleSpec = product => pairText(String(product.product_title || '').replace(/\b\d{3}\s*\/\s*\d{2,3}\s*(?:ZR|R)?\s*\d{2}\b/ig, '').replace(/\b\d{2,3}(?:\/\d{2,3})?\s*[A-Z]\b/ig, ''));
    return titleSpec(front) === titleSpec(rear);
  }
  const valid = value => value && !['undefined', 'null', '0', 'none'].includes(String(value).trim().toLowerCase());
  const country = p => valid(p.country) ? String(p.country).trim().toUpperCase() : '';
  const brands = [['Mercedes-Benz', /mercedes|benz/i], ['BMW', /(?:^|[^a-z])bmw(?:[^a-z]|$)/i], ['Audi', /(?:^|[^a-z])audi(?:[^a-z]|$)/i], ['Porsche', /porsche/i], ['Land Rover', /(?:land|range)[_ -]?rover|(?:^|[^a-z])lr(?:[^a-z]|$)/i], ['Volvo', /volvo/i], ['Jaguar', /jaguar/i], ['Tesla', /tesla/i], ['Ferrari', /ferrari/i], ['Maserati', /maserati/i], ['Bentley', /bentley/i], ['Lamborghini', /lamborghini/i], ['McLaren', /mclaren/i]];
  function approvals(p) {
    const found = new Map();
    const codeGroups = [
      ['Alfa Romeo', 'AR ARR'], ['Alpine', 'A11 A29 A39'], ['Alpina', 'ALP'],
      ['Aston Martin', 'AML A6A A7A A8A A8B AM4 AM8 AM9 AMP AMS'],
      ['Audi', 'AO AO1 AO2 AOE AOE1 RO RO1 RO2 R0 RE0'],
      ['BMW', '* I* II* *1 *S1'], ['Bugatti', 'BG'],
      ['Bentley', 'B B1 BC BL BH'], ['Chery', 'CH'], ['Dallara', 'ME2'],
      ['Ferrari', 'F F01 F02 F03 F04 K1 K2 K3'], ['Ford Performance', 'FP'],
      ['Genesis', 'GOE'], ['Honda', 'H0'], ['Hyundai', 'HN'],
      ['Jaguar', 'J JRS JLR'], ['Jeep', 'JP'], ['Karma', 'KRM'],
      ['Lamborghini', 'L L1'], ['Land Rover', 'LR LR1 LR2 LR3 LR5'],
      ['Li Auto', 'LA'], ['Lotus', 'LTS'], ['Lucid', 'LM1'], ['Lynk & Co', 'LK'],
      ['Maserati', 'MGT MGT1 MGT2'], ['McLaren', 'MC MC1 MC2'],
      ['Mercedes-Benz', 'MO MO1 MO1A MO1B MO1EXT MO2 MOE MOE-S MO-P MO-S MO-V'],
      ['NIO', 'I'], ['Pagani', 'HP'], ['Polestar', 'POL'],
      ['Porsche', 'N0 N1 N2 N3 N4 N5 NA0 NA1 NA2 NA5 NA6 NC0 ND0 ND1 NE0 NF0 NF1 NG0'],
      ['Renault', 'R'], ['Rivian', 'RIV'], ['Tesla', 'T0 T1 T2'],
      ['Volkswagen', '+'], ['Volvo', 'VOL'], ['Zeekr', 'ZK'],
      ['GM (Cadillac / Chevrolet / GMC / Pontiac)', 'TPC']
    ];
    function add(name, icon) { if (!found.has(name) || icon) found.set(name, icon); }
    function readCodes(value, icon, explicit) {
      const tokens = String(value).toUpperCase().replace(/[★☆⭐]/g, '*').split(/[\s,;|/()_\.]+/).filter(Boolean);
      tokens.forEach(token => {
        if (/^\*MO(?:E)?$/.test(token)) { add('BMW', icon); add('Mercedes-Benz', icon); return; }
        for (const [name, codes] of codeGroups) {
          if (!explicit && (token.length === 1 || ['FP', 'HP', 'BC', 'BL', 'BH', 'LA', 'LK', 'CH', 'BG', 'JP', 'R0'].includes(token))) continue;
          if (codes.split(' ').includes(token)) add(name, icon);
        }
      });
    }
    [p.oem, p.markings].filter(valid).flatMap(v => String(v).split(',')).forEach(value => {
      let filename = value;
      let icon = '';
      try {
        const url = new URL(value);
        filename = decodeURIComponent(url.pathname.split('/').pop()).replace(/\.(png|jpe?g|webp|svg|avif|gif)$/i, '');
        if (url.protocol === 'https:' && url.hostname === 'cdn.shopify.com') icon = url.href;
      } catch {}
      for (const [name, pattern] of brands) if (pattern.test(filename)) add(name, icon);
      for (const [name] of codeGroups) if (filename.replace(/[_-]/g, ' ').toLowerCase() === name.toLowerCase()) add(name, icon);
      readCodes(filename, icon, true);
    });
    const title = String(p.product_title || '');
    readCodes(title, '', false);
    for (const match of title.matchAll(/\(([^()]*)\)/g)) readCodes(match[1], '', true);
    return found;
  }
  function matches(row) {
    const products = parts(row);
    for (const [key, match] of [['tm_origin', (p, value) => country(p) === value], ['tm_oem', (p, value) => approvals(p).has(value)]]) {
      const values = params.getAll(key);
      if (values.length && !products.every(p => values.some(v => match(p, v)))) return false;
    }
    return products.every(p => {
      const price = Number(p.product_price);
      return (!params.has('tm_min') || price >= Number(params.get('tm_min'))) && (!params.has('tm_max') || price <= Number(params.get('tm_max')));
    });
  }
  function element(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  }
  function group(panel, key, title, count = 0) {
    const details = element('details', 'tm-extra');
    details.dataset.filterKey = key;
    details.open = false;
    const summary = element('summary', '', title);
    if (count) summary.append(element('span', 'tm-badge', count));
    details.append(summary);
    panel.append(details);
    return details;
  }
  function navigate(update) {
    const url = new URL(location.href);
    update(url.searchParams);
    location.href = url.href;
  }
  function choiceGroup(panel, key, title, options, searchText) {
    const details = group(panel, key, title, params.getAll(key).length);
    const list = element('div', 'tm-options');
    if (searchText) {
      const search = element('input');
      search.type = 'search';
      search.placeholder = searchText;
      search.setAttribute('aria-label', searchText);
      search.addEventListener('input', () => {
        for (const row of list.children) row.hidden = !row.dataset.label.includes(search.value.toLocaleLowerCase().trim());
      });
      details.append(search);
    }
    options.forEach(({value, label, count, icon}) => {
      const row = element('label', 'tm-option');
      row.dataset.label = label.toLocaleLowerCase();
      const input = element('input');
      input.type = 'checkbox';
      input.checked = params.getAll(key).includes(value);
      input.addEventListener('change', () => navigate(q => input.checked ? q.append(key, value) : q.delete(key, value)));
      row.append(input);
      if (icon) {
        const img = element('img');
        img.src = icon;
        img.alt = '';
        img.width = 20;
        img.height = 20;
        row.append(img);
      }
      row.append(element('span', '', label), element('small', '', count));
      list.append(row);
    });
    details.append(list);
    if (!options.length) details.append(element('p', '', text.empty));
  }
  function priceGroup(panel) {
    const prices = base.flatMap(parts).map(p => Number(p.product_price)).filter(Number.isFinite);
    const selected = ['tm_min', 'tm_max'].filter(key => params.has(key));
    const details = group(panel, 'tm_price', text.price, selected.length ? 1 : 0);
    if (!prices.length) { details.append(element('p', '', text.empty)); return; }
    const floor = Math.floor(Math.min(...prices, ...selected.map(key => Number(params.get(key)))));
    const ceiling = Math.max(floor + 1, Math.ceil(Math.max(...prices, ...selected.map(key => Number(params.get(key))))));
    const form = element('form');
    const range = element('div', 'tm-range');
    const numbers = element('div', 'tm-price-numbers');
    const inputs = {};
    for (const [key, title, initial] of [['tm_min', text.min, floor], ['tm_max', text.max, ceiling]]) {
      const slider = element('input');
      const number = element('input');
      slider.type = 'range'; number.type = 'number';
      for (const input of [slider, number]) {
        input.min = floor; input.max = ceiling; input.step = 1;
        input.value = params.has(key) ? params.get(key) : initial;
        input.setAttribute('aria-label', title + ' (' + text.currency + ')');
      }
      number.required = true;
      const label = element('label', '', text.currency + ' · ' + title);
      label.append(number);
      numbers.append(label); range.append(slider);
      inputs[key] = {slider, number};
    }
    function sync(key, source) {
      const otherKey = key === 'tm_min' ? 'tm_max' : 'tm_min';
      const other = Number(inputs[otherKey].number.value);
      let value = Math.max(floor, Math.min(ceiling, Number(source.value)));
      value = key === 'tm_min' ? Math.min(value, other) : Math.max(value, other);
      inputs[key].number.value = value; inputs[key].slider.value = value;
      paint();
    }
    function paint() {
      range.style.setProperty('--low', (Number(inputs.tm_min.number.value) - floor) / (ceiling - floor) * 100 + '%');
      range.style.setProperty('--high', (Number(inputs.tm_max.number.value) - floor) / (ceiling - floor) * 100 + '%');
    }
    for (const key of Object.keys(inputs)) {
      inputs[key].slider.addEventListener('input', () => sync(key, inputs[key].slider));
      inputs[key].number.addEventListener('change', () => sync(key, inputs[key].number));
    }
    const apply = element('button', '', text.apply);
    apply.type = 'submit';
    form.append(range, numbers, apply);
    form.addEventListener('submit', event => {
      event.preventDefault();
      navigate(q => {
        for (const key of Object.keys(inputs)) {
          const value = Number(inputs[key].number.value);
          if (value === (key === 'tm_min' ? floor : ceiling)) q.delete(key);
          else q.set(key, value);
        }
      });
    });
    paint(); details.append(form);
  }
  async function sizeGroup(panel) {
    const details = group(panel, 'tm_size', text.size, ['width', 'height', 'rim'].filter(k => params.has(k)).length);
    const form = element('form');
    const inputs = {};
    for (const [key, title] of [['width', text.width], ['height', text.profile], ['rim', text.rim]]) {
      const label = element('label', 'tm-size-label', title);
      const select = element('select'); select.name = key;
      select.setAttribute('aria-label', title);
      select.append(new Option(params.get(key) || '—', params.get(key) || ''));
      select.disabled = true; inputs[key] = select; label.append(select); form.append(label);
    }
    const apply = element('button', '', text.apply); apply.type = 'submit'; apply.disabled = true;
    form.append(apply); details.append(form);
    if (params.has('rear_width')) details.append(element('p', '', text.rear));
    try {
      sizePromise ||= fetch('https://search.tyresme.com/tyre/tyre', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({shop: text.shop})}).then(response => {
        if (!response.ok) throw new Error('size');
        return response.json();
      }).then(json => json.data.tyre_width).catch(() => ({})).then(sizes => window.tyresmeStockSizes ? window.tyresmeStockSizes(sizes) : sizes);
      const sizes = await sizePromise;
      if (!sizes || typeof sizes !== 'object') throw new Error('size');
      function fill(select, values, preferred) {
        select.replaceChildren();
        values.map(String).sort((a, b) => a.localeCompare(b, undefined, {numeric: true})).forEach(value => select.append(new Option(value, value)));
        if (values.map(String).includes(preferred)) select.value = preferred;
        select.disabled = !values.length;
      }
      function rims() { fill(inputs.rim, sizes[inputs.width.value]?.[inputs.height.value] || [], inputs.rim.value); }
      function profiles() { fill(inputs.height, Object.keys(sizes[inputs.width.value] || {}), inputs.height.value); rims(); }
      fill(inputs.width, Object.keys(sizes), params.get('width')); profiles();
      inputs.width.addEventListener('change', profiles); inputs.height.addEventListener('change', rims);
      apply.disabled = false;
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (Object.values(inputs).some(input => !input.value)) return;
        navigate(q => {
          [...extraKeys, 'brand', 'pattern', 'model', 'availability'].forEach(key => q.delete(key));
          Object.entries(inputs).forEach(([key, input]) => q.set(key, input.value));
        });
      });
    } catch { details.append(element('p', '', text.unavailable)); }
  }
  function mount(panel) {
    panel.querySelectorAll('.tm-extra').forEach(node => node.remove());
    sizeGroup(panel); priceGroup(panel);
    const countries = new Set(base.flatMap(parts).map(country).filter(Boolean));
    params.getAll('tm_origin').forEach(value => countries.add(value));
    choiceGroup(panel, 'tm_origin', text.origin, [...countries].sort().map(value => ({value, label: value, count: base.filter(row => parts(row).every(p => country(p) === value)).length})), text.countries);
    const approved = new Map();
    base.flatMap(parts).forEach(p => approvals(p).forEach((icon, name) => approved.set(name, icon)));
    params.getAll('tm_oem').forEach(value => { if (!approved.has(value)) approved.set(value, ''); });
    choiceGroup(panel, 'tm_oem', text.oem, [...approved].sort().map(([value, icon]) => ({value, label: value === 'Land Rover' ? 'Land Rover / Range Rover' : value, icon, count: base.filter(row => parts(row).every(p => approvals(p).has(value))).length})), text.vehicles);
  }
  window.tyresmeFilters = {
    async completePairs(rows, query, endpoint) {
      const selected = new URLSearchParams(query);
      if (!['rear_width', 'rear_height', 'rear_rim'].every(key => selected.has(key))) return rows;
      const frontQuery = new URLSearchParams(selected);
      ['rear_width', 'rear_height', 'rear_rim', ...extraKeys].forEach(key => frontQuery.delete(key));
      const rearQuery = new URLSearchParams(frontQuery);
      ['width', 'height', 'rim'].forEach(key => rearQuery.set(key, selected.get('rear_' + key)));
      const read = async params => {
        const response = await fetch(endpoint + '?' + params, {credentials: 'include'});
        if (!response.ok) throw new Error('Size search failed');
        const products = await response.json();
        if (!Array.isArray(products)) throw new Error('Invalid size results');
        return products.map(correctedProduct);
      };
      const [fronts, rears] = await Promise.all([read(frontQuery), read(rearQuery)]);
      const pairs = [];
      const seen = new Set();
      fronts.forEach(front => rears.forEach(rear => {
        const pair = {front, rear};
        const key = `${front.variant_id || front.product_id}:${rear.variant_id || rear.product_id}`;
        if (matchingPair(pair, selected) && !seen.has(key)) { seen.add(key); pairs.push(pair); }
      }));
      return pairs;
    },
    prepare(rows, query, hideSoldOut) {
      params = new URLSearchParams(query);
      base = rows.map(correctedRow).filter(row => matchingPair(row, params) && (!hideSoldOut || parts(row).every(p => Number(p.inventory_quantity) > 0)));
      return base.filter(matches);
    },
    mount
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tyresme-filter-desktop"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const results = document.getElementById('custom_search_results');
    if (results) {
      let queued = false;
      const alignPairRows = () => {
        queued = false;
        results.querySelectorAll('.product-item').forEach(card=>{
          const dropdown=card.querySelector('.fggddgg .dropdown');
          const input=card.querySelector('.quantity-input__input');
          if(dropdown && input && !dropdown.querySelector('.tm-native-quantity')){
            const select=document.createElement('select');select.className='tm-native-quantity';select.setAttribute('aria-label',input.getAttribute('aria-label') || 'Quantity');
            const choices=[...dropdown.querySelectorAll('.dropdown-content p')];
            choices.forEach(choice=>{const option=document.createElement('option');option.value=choice.textContent.trim();option.textContent=option.value;select.append(option);});
            select.value=input.value;
            select.addEventListener('change',()=>{choices.find(choice=>choice.textContent.trim()===select.value)?.click();});
            dropdown.append(select);
          }
          const native=dropdown?.querySelector('.tm-native-quantity');if(native)native.value=dropdown.querySelector('.dropdown-button').textContent.trim();
          const origin=card.querySelector('.ser-num-all');origin?.nextElementSibling?.classList.add('tm-row-prices');
          if(!card.querySelector('.tm-row-warranty')){
            const badge=card.querySelector('.warranty-badge');
            if(badge){const text=document.createElement('p');text.className='tm-row-warranty';text.textContent=[badge.querySelector('.years')?.textContent, badge.querySelector('.label')?.textContent].filter(Boolean).join(' ').trim().toLowerCase();card.firstElementChild.append(text);}
          }
        });
        results.querySelectorAll('.with_rear_product').forEach(pair => {
          ['.top-main-pro', '.product-item__media', '.no-all-line', '.ser-num-all'].forEach(selector => {
            const rows = [...pair.querySelectorAll(selector)];
            rows.forEach(row => row.style.removeProperty('min-height'));
            if (window.matchMedia('(max-width: 749px)').matches && rows.length === 2) {
              const height = Math.ceil(Math.max(...rows.map(row => row.getBoundingClientRect().height)));
              rows.forEach(row => row.style.minHeight = `${height}px`);
            }
          });
        });
      };
      const schedulePairRows = () => { if (!queued) { queued = true; requestAnimationFrame(alignPairRows); } };
      new MutationObserver(schedulePairRows).observe(results, {childList: true, subtree: true});
      results.addEventListener('load', schedulePairRows, true);
      window.addEventListener('resize', schedulePairRows);
      document.fonts.ready.then(schedulePairRows);
      schedulePairRows();
    }
    const panel = document.getElementById('search_filter');
    if (!panel || panel.dataset.tyresmeStyled) return;
    panel.dataset.tyresmeStyled = 'true';
    const desktop = window.matchMedia('(min-width: 990px)');
    const keys = ['brand', 'pattern', 'model', 'availability', 'tm_origin', 'tm_oem', 'tm_min', 'tm_max'];
    const order = ['tm_size', 'tm_price', 'brand', 'pattern', 'model', 'availability', 'tm_origin', 'tm_oem'];
    const params = new URLSearchParams(window.location.search);
    const observer = new MutationObserver(enhance);
    function enhance() {
      observer.disconnect();
      const groups = Array.from(panel.querySelectorAll('.filter_main'));
      {
        const allGroups = Array.from(panel.querySelectorAll(':scope > .filter_main, :scope > .tm-extra'));
        const key = group => group.dataset.filterKey || group.querySelector('.filter_inner')?.id.replace('_inner', '');
        allGroups.sort((a, b) => order.indexOf(key(a)) - order.indexOf(key(b)));
        allGroups.forEach(group => panel.append(group));
      }
      groups.forEach(group => {
        const title = group.querySelector('.filter_title');
        const inner = group.querySelector('.filter_inner');
        if (!title || !inner) return;
        const key = inner.id.replace('_inner', '');
        title.setAttribute('role', 'button');
        title.tabIndex = 0;
        title.setAttribute('aria-controls', inner.id);
        title.setAttribute('aria-expanded', String(inner.style.display !== 'none'));
        const selected = params.getAll(key);
        title.querySelector('.tyresme-filter-count')?.remove();
        if (selected.length) {
          const badge = document.createElement('span');
          badge.className = 'tyresme-filter-count';
          badge.textContent = selected.length;
          title.insertBefore(badge, title.querySelector('.icon'));
        }
        inner.querySelectorAll('.m-all-fliter').forEach(option => {
          option.setAttribute('role', 'button');
          option.tabIndex = 0;
          option.setAttribute('aria-pressed', String(selected.includes(option.textContent.trim())));
        });
      });
      panel.querySelector('.tyresme-filter-clear')?.remove();
      const existing = document.querySelector('.filter-bar__active-filters [data-clear-all-filters]');
      if (existing && groups.length) {
        const clear = document.createElement('a');
        clear.className = 'tyresme-filter-clear';
        clear.textContent = existing.textContent.trim() + ' (' + keys.reduce((count, key) => count + params.getAll(key).length, 0) + ')';
        const url = new URL(window.location.href);
        keys.forEach(key => url.searchParams.delete(key));
        clear.href = url.href;
        panel.prepend(clear);
      }
      observer.observe(panel, { childList: true });
    }
    panel.addEventListener('keydown', event => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[role="button"]')) {
        event.preventDefault();
        event.target.click();
      }
    });
    panel.addEventListener('click', () => {
      panel.querySelectorAll('.filter_title').forEach(title => title.setAttribute('aria-expanded', String(title.nextElementSibling.style.display !== 'none')));
    });
    desktop.addEventListener('change', enhance);
    enhance();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tyresme-mobile-app"] && !Shopify.designMode) return;
  try {
    (()=>{
 const nav=document.querySelector('.tm-mobile-nav');if(!nav)return;
 const siteLoader=document.createElement('div');siteLoader.className='tm-site-loading';siteLoader.hidden=true;siteLoader.setAttribute('role','status');siteLoader.setAttribute('aria-label','Loading');
 siteLoader.innerHTML='<svg aria-hidden="true" viewBox="0 0 100 100"><circle cx="50" cy="50" r="46" fill="#121212"/><circle cx="50" cy="50" r="41" fill="none" stroke="#444" stroke-width="6" stroke-dasharray="3 4"/><circle cx="50" cy="50" r="34" fill="#bbb" stroke="#777" stroke-width="2"/><circle cx="50" cy="50" r="29" fill="#262626"/><g fill="#e8e8e8" stroke="#999" stroke-width="1"><path transform="rotate(0 50 50)" d="M46 48 43 20 51 17 54 47Z"/><path transform="rotate(72 50 50)" d="M46 48 43 20 51 17 54 47Z"/><path transform="rotate(144 50 50)" d="M46 48 43 20 51 17 54 47Z"/><path transform="rotate(216 50 50)" d="M46 48 43 20 51 17 54 47Z"/><path transform="rotate(288 50 50)" d="M46 48 43 20 51 17 54 47Z"/></g><circle cx="50" cy="50" r="10" fill="#aaa" stroke="#eee" stroke-width="2"/><circle cx="50" cy="50" r="5" fill="#e5000b"/></svg>';document.body.append(siteLoader);
 let loaderTimer;
 const hideSiteLoader=()=>{clearTimeout(loaderTimer);siteLoader.hidden=true};
 const showSiteLoader=()=>{if(!siteLoader.hidden)return;siteLoader.hidden=false;loaderTimer=setTimeout(hideSiteLoader,700)};
 window.addEventListener('beforeunload',showSiteLoader);
 document.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank'||link.hasAttribute('download'))return;const url=new URL(link.href,location.href);if(url.origin!==location.origin||url.pathname===location.pathname&&url.search===location.search)return;setTimeout(()=>{if(!event.defaultPrevented)showSiteLoader()},0)},true);
 window.addEventListener('pageshow',hideSiteLoader);
 window.addEventListener('load',hideSiteLoader,{once:true});
 const openAddedCart=()=>{if(sessionStorage.getItem('tm-open-added-cart')!=='1')return;const trigger=document.querySelector('[data-js-cart-icon]');if(trigger){sessionStorage.removeItem('tm-open-added-cart');trigger.click()}};
 if(document.readyState==='complete')setTimeout(openAddedCart,0);else window.addEventListener('load',openAddedCart,{once:true});
 // The header drawer must visit the vehicle-details cart before payment.
 const vehicleCart=()=>location.assign((window.Shopify?.routes?.root||'/')+'cart');
 document.addEventListener('click',event=>{if(event.target.closest('.quick-cart__submit[name="checkout"]')){event.preventDefault();event.stopImmediatePropagation();vehicleCart()}},true);
 document.addEventListener('submit',event=>{if(event.target.querySelector('.quick-cart__submit[name="checkout"]')){event.preventDefault();event.stopImmediatePropagation();vehicleCart()}},true);
 // Tidio isolates its launcher in a shadow root. Move only the closed mobile launcher.
 const alignChat=()=>{const root=document.getElementById('tidio-chat')?.shadowRoot;if(!root)return false;if(!root.querySelector('[data-tm-chat-position]')){const style=document.createElement('style');style.dataset.tmChatPosition='';style.textContent='@media(max-width:749px){#button.chat-closed{top:auto!important;bottom:calc(68px + env(safe-area-inset-bottom) + var(--tm-preview-offset,0px) + 12px)!important}}';root.append(style)}return true};
 let chatAttempts=0;const chatTimer=setInterval(()=>{if(alignChat()||++chatAttempts>=60)clearInterval(chatTimer)},500);alignChat();
 let previewBar;
 const measurePreview=()=>{const box=previewBar?.getBoundingClientRect();document.body.style.setProperty('--tm-preview-offset',`${box&&getComputedStyle(previewBar).display!=='none'?Math.max(0,Math.min(box.height,innerHeight-box.top)):0}px`)};
 const watchPreview=()=>{const el=document.getElementById('PBarNextFrameWrapper');if(el&&el!==previewBar){previewBar=el;new ResizeObserver(measurePreview).observe(el);measurePreview()}};
 watchPreview();new MutationObserver(watchPreview).observe(document.body,{childList:true});addEventListener('resize',measurePreview);
 const path=location.pathname.replace(/\/$/,'')||'/';
 nav.querySelectorAll('a').forEach(a=>{if((new URL(a.href).pathname.replace(/\/$/,'')||'/')===path)a.setAttribute('aria-current','page')});
 const shortcuts=document.querySelector('.tm-mobile-shortcuts'),hero=document.querySelector('.tyres-banner');
 if(shortcuts&&hero){hero.closest('.shopify-section').after(shortcuts);shortcuts.classList.add('tm-mobile-ready')}
 const trigger=nav.querySelector('[data-tm-mobile-search]');
 const connect=()=>{const toggle=document.getElementById('tm-search-toggle');if(!toggle)return;
 const sync=()=>trigger.setAttribute('aria-expanded',toggle.getAttribute('aria-expanded')||'false');sync();
 new MutationObserver(sync).observe(toggle,{attributes:true,attributeFilter:['aria-expanded']});
 const dialog=document.querySelector('.tm-search-dialog'),bar=document.getElementById('tm-search-bar'),anchor=document.createComment('search home');bar.before(anchor);
 const choices=document.querySelector('.hhhg-main'),choicesAnchor=document.createComment('size choices');if(choices)choices.before(choicesAnchor);
 const modes=dialog.querySelectorAll('[data-tm-mode]');
 const syncModes=()=>{const isVehicle=bar.querySelector('.vehicle_btn_main').style.display!=='none';modes.forEach(b=>b.setAttribute('aria-pressed',String((b.dataset.tmMode==='vehicle')===isVehicle)))};
 modes.forEach(b=>b.addEventListener('click',()=>{const isVehicle=bar.querySelector('.vehicle_btn_main').style.display!=='none';if((b.dataset.tmMode==='vehicle')!==isVehicle)bar.querySelector('.change_search_btn').click();syncModes()}));
 syncModes();
 const mobile=matchMedia('(max-width:749px)');
 const collapse=()=>{if(toggle.getAttribute('aria-expanded')==='true')toggle.click()};
 if(mobile.matches)collapse();
 const close=()=>{if(dialog.open)dialog.close()};
 dialog.addEventListener('close',()=>{collapse();anchor.after(bar);if(choices){choices.querySelector('.cancel-btn')?.click();choicesAnchor.after(choices)}trigger.focus()});
 dialog.querySelector('[data-tm-search-close]').addEventListener('click',close);
 dialog.addEventListener('click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)close()}});
 mobile.addEventListener('change',()=>{close();if(mobile.matches)collapse()});
 trigger.addEventListener('click',()=>{if(!mobile.matches)return;if(dialog.open){close();return}dialog.querySelector('[data-tm-search-slot]').append(bar);if(choices)dialog.querySelector('[data-tm-search-slot]').append(choices);if(toggle.getAttribute('aria-expanded')!=='true')toggle.click();dialog.showModal()});
 };if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>queueMicrotask(connect),{once:true});else queueMicrotask(connect);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tyresme-search-toggle"] && !Shopify.designMode) return;
  try {
    (() => {
  const button = document.getElementById('tm-search-toggle');
  const bar = button?.previousElementSibling;
  if (!button || !bar?.matches('section.Search')) return;
  bar.id = 'tm-search-bar';
  const label = button.querySelector('[data-tm-toggle-label]');
  function setExpanded(expanded) {
    button.setAttribute('aria-expanded', String(expanded));
    label.textContent = expanded ? button.dataset.closeLabel : button.dataset.openLabel;
    bar.classList.toggle('tm-search-collapsed', !expanded);
    bar.inert = !expanded;
  }
  setExpanded(document.body.classList.contains('template-index') && !matchMedia('(max-width:749px)').matches);
  const measure = () => button.style.setProperty('--tm-search-height', `${bar.getBoundingClientRect().height}px`);
  new ResizeObserver(measure).observe(bar);
  measure();
  button.hidden = false;
  button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
  bar.addEventListener('keydown', event => {
    if (event.key === 'Escape') { setExpanded(false); button.focus(); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tyresme-shared-listings"] && !Shopify.designMode) return;
  try {
    (()=>{
let quantityMenu=null,quantityTrigger=null;
function closeQuantity(){quantityMenu?.remove();quantityMenu=null;quantityTrigger?.setAttribute('aria-expanded','false');quantityTrigger=null}
function openQuantity(trigger,choices,value,choose){
const same=quantityTrigger===trigger;closeQuantity();if(same||!choices.length)return;
quantityTrigger=trigger;trigger.setAttribute('aria-expanded','true');quantityMenu=document.createElement('div');quantityMenu.className='tm-listing-quantity-menu';quantityMenu.setAttribute('role','listbox');quantityMenu.setAttribute('aria-label','Quantity');
choices.forEach(q=>{const b=document.createElement('button');b.type='button';b.textContent=q;b.setAttribute('role','option');b.setAttribute('aria-selected',String(q===value));b.addEventListener('click',()=>{choose(q);closeQuantity();trigger.focus()});quantityMenu.append(b)});
document.body.append(quantityMenu);const r=trigger.getBoundingClientRect();quantityMenu.style.left=(r.left+scrollX)+'px';quantityMenu.style.top=(r.bottom+scrollY+3)+'px';quantityMenu.style.minWidth=Math.max(64,r.width)+'px';
}
document.addEventListener('click',e=>{if(quantityMenu&&!quantityMenu.contains(e.target)&&!quantityTrigger?.contains(e.target))closeQuantity()});
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeQuantity()});window.addEventListener('resize',closeQuantity);
const funnel='<svg class="tm-listing-funnel" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 4h18l-7 8v7l-4 2v-9z"/></svg>';
function enhance(){
document.querySelectorAll('.collection__products').forEach(grid=>grid.classList.add('tm-shared-products'));
document.querySelectorAll('.tm-shared-products .product-item').forEach(card=>{
const origin=card.querySelector('.ser-num-all');origin?.nextElementSibling?.classList.add('tm-row-prices');
if(!card.querySelector('.tm-row-warranty')){const badge=card.querySelector('.warranty-badge');if(badge){const p=document.createElement('p');p.className='tm-row-warranty';p.textContent=[badge.querySelector('.years')?.textContent,badge.querySelector('.label')?.textContent].filter(Boolean).join(' ').trim();card.firstElementChild.append(p)}}
const dropdown=card.querySelector('.fggddgg .dropdown'),input=card.querySelector('.quantity-input__input');
const trigger=dropdown?.querySelector('.dropdown-button');
if(trigger&&!trigger.dataset.tmListingQuantity){trigger.dataset.tmListingQuantity='true';trigger.setAttribute('role','button');trigger.tabIndex=0;trigger.setAttribute('aria-label','Quantity');trigger.setAttribute('aria-haspopup','listbox');
const activate=e=>{if(innerWidth<750)return;e.preventDefault();e.stopImmediatePropagation();const items=[...dropdown.querySelectorAll('.dropdown-content p')];openQuantity(trigger,items.map(p=>p.textContent.trim()),input.value,q=>items.find(p=>p.textContent.trim()===q)?.click())};trigger.addEventListener('click',activate,true);trigger.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){activate(e)}})}

if(dropdown&&input&&!dropdown.querySelector('.tm-native-quantity')){const select=document.createElement('select');select.className='tm-native-quantity';select.setAttribute('aria-label','Quantity');const choices=[...dropdown.querySelectorAll('.dropdown-content p')];choices.forEach(p=>select.add(new Option(p.textContent.trim(),p.textContent.trim())));select.value=input.value;select.addEventListener('change',()=>choices.find(p=>p.textContent.trim()===select.value)?.click());dropdown.append(select)}
});
document.querySelectorAll('.collection [data-tags-dropdown]').forEach(button=>{if(!button.querySelector('.tm-listing-funnel')){button.insertAdjacentHTML('beforeend',funnel);button.setAttribute('aria-label','Filter')}});
document.querySelectorAll('.collection [data-sort-dropdown]').forEach(button=>{const selected=document.querySelector('.collection [data-sort-item-input]:checked')?.closest('label')?.querySelector('.filter-item__label')?.textContent.trim();if(selected){let text=[...button.childNodes].find(n=>n.nodeType===3&&n.textContent.trim());if(text)text.textContent='Sort: '+selected;}});
document.querySelectorAll('.tm-category').forEach(section=>{
if(!section.querySelector('.tm-listing-toolbar')){const sort=section.querySelector('[data-sort]')?.closest('label'),button=section.querySelector('.tm-category__filter-toggle');if(sort&&button){const row=document.createElement('div');row.className='tm-listing-toolbar';button.before(row);row.append(sort,button);button.insertAdjacentHTML('beforeend',funnel);button.setAttribute('aria-label','Filter')}}
section.querySelectorAll('.tm-category__card').forEach(card=>{
const origin=card.querySelector('.tm-category__origin');if(origin&&!origin.dataset.tmIcons){origin.dataset.tmIcons='true';[...origin.children].forEach((span,i)=>{span.insertAdjacentHTML('afterbegin',i===0?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c-5 5-5 13 0 18M12 3c5 5 5 13 0 18"/></svg>':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 2v6m8-6v6M4 10h16m-12 4h3m2 0h3m-8 3h3"/></svg>')})}
const select=card.querySelector('.tm-category__controls select');if(select&&!card.querySelector('.tm-category__desktop-quantity')){const button=document.createElement('button');button.type='button';button.className='tm-category__desktop-quantity';button.textContent=select.value;button.setAttribute('aria-label','Quantity');button.setAttribute('aria-haspopup','listbox');select.before(button);button.addEventListener('click',e=>{e.stopPropagation();openQuantity(button,[...select.options].map(o=>o.value),select.value,q=>{select.value=q;select.dispatchEvent(new Event('change',{bubbles:true}));button.textContent=q})});select.addEventListener('change',()=>button.textContent=select.value)}

let prices=card.querySelector('.tm-category__price-block');if(!prices){prices=document.createElement('div');prices.className='tm-category__price-block';const p=card.querySelector('.tm-category__prices'),total=card.querySelector('.tm-category__total');p.before(prices);prices.append(p,total)}
const fitted=card.querySelector('.tm-fitted-price');if(fitted&&fitted.parentElement!==prices)prices.append(fitted);
if(!card.querySelector('.tm-category__plain-warranty')){const badge=card.querySelector('.tm-category__warranty');if(badge){const text=document.createElement('p');text.className='tm-category__plain-warranty';text.textContent=badge.querySelector('b').textContent.trim()+' warranty';card.append(text)}}
});
});
}
let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;observer.disconnect();enhance();observer.observe(document.getElementById('main')||document.body,{childList:true,subtree:true})})};const observer=new MutationObserver(schedule);schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
